import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    CriteriaMutationResourceSchema,
    defaultCriteriaResource,
    useCriteriaActions,
} from '../../../../../resource/resources/artifacts/criteria/criteriaResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { CriteriaContent } from './CriteriaContent';

export const CriteriaEditDialog = ({
    onClose,
    objectId,
    versionedInId,
}: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const criteriaActions = useCriteriaActions();
    const criteriaQuery = criteriaActions.useGetResourceByObjectIdAndVersionedIn(objectId, versionedInId);
    const updateCriteria = criteriaActions.useUpdateResource();
    const validation = criteriaActions.useValidateResource(criteriaQuery.data?.id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: CriteriaMutationResourceSchema,
        defaultValues: defaultCriteriaResource,
        submitHandler: async (data) => {
            await updateCriteria.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: criteriaQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Criteria'}
            resourceType={ResourceType.CRITERIA}
            resourceValidationResult={validation.data}
            metaDataInfo={criteriaQuery.data}
        >
            <QueryBaseComponent name="Criteria" query={criteriaQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <CriteriaContent
                        form={form}
                        formNames={formNames}
                        readOnly={readOnly}
                        id={criteriaQuery.data?.id}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
